import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
const CodeSocal2= () => {
const codeString2 = `
while True:
    print("Running...")
    utc_now = datetime.now(UTC)
    pacific = timezone("US/Pacific")

    pacific_now = utc_now.astimezone(pacific)

    fmt = "%H:%M:%S"
    now = pacific_now.strftime(fmt)
    print("TIME IN PACIFIC", now)
    nowTime = datetime.strptime(now, fmt).time()

    if nowTime >= defaultTime:

        presentday = datetime.now()
        yesterday = presentday - timedelta(days=1)
        tomorrow  = presentday + timedelta(days=1)

        yesterdayStr = str(yesterday.strftime('%m-%d-%Y'))
        yesterdayMonth = yesterdayStr[:2]
        yesterdayDay = yesterdayStr[3:5]
        yesterdayYear = yesterdayStr[6:10]
        
        yesterdayStr = yesterdayYear + "-" + yesterdayMonth + "-" + yesterdayDay
        try:
            url = requests.get("https://socalfurs.com/databaseconnect.php")
            data = url.json()
        except requests.ConnectionError as e:
            print(e)
        for key,val in data.items():
            arr = val
        
        flag = False
        idArr = []
        for event in arr:
            print(event["date"])
            print("YESTERDAY. :",yesterdayStr)
            if str(event["date"]) == yesterdayStr:
                idArr.append(event["id"])
                flag = True
        
        if not flag:
            continue
            
        try:
            conn = mysql.connector.connect(
                host=db_host,
                user=db_username,
                password=db_password,
                database=db_name
            )

            cursor = conn.cursor()
            
            sql = "DELETE FROM events_copy WHERE id = %s"
            for i in idArr:
                cursor.execute(sql,(i,))
            conn.commit()
            cursor.close()
            conn.close()

        except mysql.connector.Error as err:
            print(err)
            time_module.sleep(60*60*24)
     
        time_module.sleep(60*60*24)
    else:
        print("Not midnight yet..")
        time_module.sleep(60)

    `

  return (
    <div>
         <p style={{fontSize:"18px",textDecoration:"None"}}>

                    This is another script running on the vps server and checking the mysql database 
                    if there is any old
                    events on the map. Old as in, if the event already happened the script will
                    automatically delete all the events. For example, on a certain day we can have 
                    multiple events. So, every midnight the script chekcs if the message is 
                    a day old, vs the date we are currently checking which is midnight. If its not 
                    then each event that happened yesteday needs to be deleted.

                 </p>
                               <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Step1 : Convert yestrday event and todays event.
             </p>
                          <p style={{fontSize:"18px",textDecoration:"None"}}>

                        I use datetime objexts which are from python library. I basically format the yeterday's
                        date and compare it to the date we are currently on. Which will be the present since the
                        script checks every midnight. 
                 </p>
                   <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Step 2: Call the request from the backend and delete
             </p>

              <p style={{fontSize:"18px",textDecoration:"None"}}>

                         We then call the requests to the backend "https://socalfurs.com/databaseconnect.php"
                        grab the data and check each event and check if the event is of the yesterday string.
                        If it is we grab the id and then delete those events from the mysql database.
                 </p>

        <div style={{fontSize:"16px",textDecoration:"None"}}>
        <SyntaxHighlighter language="python" style={a11yDark}>
      {codeString2}
    </SyntaxHighlighter>
    </div>

    </div>

    


  );
};

export default CodeSocal2;